import loadable from '@loadable/component'
import pMinDelay from 'p-min-delay'
import React from 'react'
// Layout
import Layout2 from './shared/layouts/Layout2'
import LayoutBlank from './shared/layouts/LayoutBlank'
import Loader from './shared/Loader'

// Lazy load component
const lazy = cb => loadable(() => pMinDelay(cb(), 200), { fallback: <Loader /> })



export const loginpage = {
  path: process.env.REACT_APP_LOGIN_ROUTE,
  component: lazy(() => import('./screens/authentication/AuthenticationLoginV4')),
  layout: LayoutBlank,
}

export const notfoundpage = {
  path: '/404',
  component: lazy(() => import('./components/pages/NotFoundScreen')),
  layout: LayoutBlank,
}

export const redirectPage = {
  path: "/redirect",
  component: lazy(() => import('./screens/redirect/Redirect')),
  layout: LayoutBlank,
}
